import React from 'react';
import { wrap } from './style';

function Spiner() {
  return <div css={wrap}></div>;
}

export default Spiner;
